import { RunParameter } from "../../../../api";
import { IParameterRenderer, RenderParamLabSettingsProps } from "../ParameterRendererAbstracts";
import { CaseRunCalculateModel, CaseRunClient, CaseRunCreateModelBase, DnaMatchCaseRunCreateModel } from "@app/api2/api";
import { ICreateRenderer } from "../CaseRunCreate";
import { InformactionDnaMatch, InformationDnaMatchState } from "../InformationDnaMatch";
import React from "react";
import { ReviewDnaMatch } from "../ReviewDnaMatch";
import moment from 'moment';
import ReactDatePicker from 'react-datepicker'
import { LabKitSelector } from "../LabKitSelector";
import { SentryMatchResults } from "../Details/Results/Sentry/SentryMatchResults";
import { SentryCaseRuns } from "../Details/Results/Sentry/SentryCaseRuns";

export class DnaMatchHandler implements IParameterRenderer, ICreateRenderer<DnaMatchCaseRunCreateModel, InformationDnaMatchState> {
    caseRunClient = new CaseRunClient();

    save(props: { labId: number, caseId: number, model: CaseRunCreateModelBase }) {
        return new CaseRunClient().createSentry(props.labId, props.caseId, props.model)
    }

    createBlankModel(props: { labId: number, caseId: number, runType: string, evidenceId?: number, ednaTestId?: number }): Promise<DnaMatchCaseRunCreateModel> {
        return this.caseRunClient.new(props.labId, props.caseId, props.runType, props.evidenceId, props.ednaTestId ?? null)
    }
    renderReview(model: CaseRunCreateModelBase, onComplete: (values: any) => void, router: any) {
        return <ReviewDnaMatch parameterRenderer={this} model={model as DnaMatchCaseRunCreateModel} onComplete={onComplete} router={router} />
    }

    renderInformation(model: CaseRunCreateModelBase, onComplete: (values: any) => void, router: any, rangeOfContributors: boolean) {
        return <InformactionDnaMatch model={model as DnaMatchCaseRunCreateModel} onComplete={onComplete} router={router} />
    }

    runType: string = "dnamatch";

    canHandle(runType: string): boolean {
        return runType == this.runType;
    }

    applyInformationValuesToModel = (model: DnaMatchCaseRunCreateModel, values: InformationDnaMatchState) => {
        // model = fillWithValues(model, values, false)
        model.description = values.description;
        model.evidence = values.evidence;
        model.populationId = values.populationId;
        model.references = values.references;
        model.qualityCheckCases = values.qualityCheckCases;

        let start = new Date();
        start.setDate(new Date().getDate() - 30);
        var startPar = model.parameters.find(x => x.parameter == "uploadStartDate");
        var endPar = model.parameters.find(x => x.parameter == "uploadEndDate");

        if (startPar != null && (startPar.value == null || startPar.value == ""))
            startPar.value = moment(start).format("MM/DD/YYYY");

        if (endPar != null && (endPar.value == null || endPar.value == ""))
            endPar.value = moment(new Date()).format("MM/DD/YYYY");

        let useExtSearch = model.parameters.find(x => x.parameter == "useExtendedSearch");
        if (useExtSearch != null) {
            let hasQuality = model.qualityCheckCases?.filter(x => x.selected).length > 0;

            useExtSearch.value = hasQuality ? '0' : useExtSearch.value;
            useExtSearch.userEditable = hasQuality ? false : true;
        }

        return model;
    };

    propsComplete = (model: CaseRunCreateModelBase): void => {
        model.parameters = model.parameters.sort((a, b) => a.order < b.order ? -1 : 1)
    };


    renderParameterEditor(model: CaseRunCreateModelBase | CaseRunCalculateModel, p: RunParameter, values, onChange, errors, setFieldValue): JSX.Element {
        if (p.parameter == "kitId") {
            return (
                <LabKitSelector readOnly={false} optionalText="None" kitId={parseInt(p.value)} name={p.parameter} labId={model.labId} onChange={(ev) => onChange(p, ev)} />);
        } else {
            return (
                <ReactDatePicker autoComplete="off" className={'w100'} isClearable={true} name={p.parameter} selected={values[p.parameter] ? moment(values[p.parameter]).toDate() : null}
                    onChange={(ev) => {
                        let dateValue = ev as Date != null ? moment(ev as Date).format("MM/DD/YYYY") : null;
                        setFieldValue(p.parameter, dateValue)
                        return onChange(p, dateValue);
                    }} />

            );
        }
    }

    canRenderParameter(parameterName: string): boolean {
        return ["uploadStartDate", "uploadEndDate", "kitId"].some(pname => pname == parameterName);
    }

    renderParameterView({ model, p }): JSX.Element {
        if (p.parameter == "kitId") {
            return (
                <LabKitSelector readOnly={true} kitId={parseInt(p.value)} name={p.parameter} labId={model.labId} />
            );
        } else {
            return (
                <span>{p.value}</span>
            );
        }
    }

    renderParameterLabSettings?(p: RenderParamLabSettingsProps): JSX.Element {
        if (p.parameter == "kitId") {
            return (
                <LabKitSelector optionalText="None" readOnly={p.readOnly} kitId={parseInt(p.value)} name={p.parameter} labId={p.labId} onChange={(a) => { p.onChange(a as any) }} />
            );
        }
        return null;
    }

    renderResults?: (props: { labId: number, caseId: number, caseRunId: number }) => React.ReactElement = (props) => {
        return <SentryMatchResults caseId={props.caseId} labId={props.labId} caseRunId={props.caseRunId} />
    };

    renderRunList?: (props: {
        canCreateEvidence: boolean,
        labId: number,
        caseId: number,
        referenceId?: number
    }) => React.ReactElement = (props) => <SentryCaseRuns {...props} />


    cloneCaseRun?: (props: { labId: number, caseId: number, copyFrom: number }) => Promise<DnaMatchCaseRunCreateModel> = (props) => {
        return this.caseRunClient.cloneSentry(props.labId, props.caseId, props.copyFrom)
    }

}
